import { useState, useRef,useCallback,useEffect } from "react"

import Grid from '@material-ui/core/Grid'
import ButtonPrimary from '@base/Button'
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Filters from '@base/Filter'
import TextField from '@base/Inputs/Text'
import EventStreamLogService from "@services/EventStreamLogService"
import DialogConfirm from '@base/Dialog/DialogConfirm'
import Check from '@material-ui/icons/Check'

export const Logs = () => {
  const [loading, setLoading] = useState(false);
 const [, setRefresh] = useState();
  const [list, setList] = useState([]);

  const [listaIds, setListaIds] = useState([]);

  const [filtroINEP, setFiltroINEP] = useState();
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);
	
  const toastRef = useRef(null);

  const pageName = 'Erros Integração E2doc / Teleform / Digitação';

  const aplicarFiltros = () => {
    let f = [];

    if (filtroINEP) f.push({ field: 'inep', value: filtroINEP });

    setQuantidadeFiltrosAplicados(f.length);
    setRefresh(new Date());
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setFiltroINEP('');
    setQuantidadeFiltrosAplicados(0);
  }

  const carregarDados = useCallback(() => {
    	setLoading(true);
		EventStreamLogService.listar(filtroINEP ? filtroINEP : "").then(resultado => {
			setList(resultado.data)
		}).finally(() => setLoading(false));
	 }, [filtroINEP]);

	  useEffect(() => carregarDados(), [carregarDados]);

  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [dialogConfirmText, setDialogConfirmText] = useState("");
  const [dialogConfirmTitle, setDialogConfirmTitle] = useState("");
  const [dialogConfirmAction, setDialogConfirmAction] = useState(() => null);

  const closeDialog = () => {
    setDialogConfirmTitle("")
    setDialogConfirmText("");
    setDialogConfirmAction(() => null);
    setOpenDialogConfirm(false);
  }

  const openDialog = (title, text, action) => {
    setDialogConfirmTitle(title)
    setDialogConfirmText(text);
    setDialogConfirmAction(() => action);
    setOpenDialogConfirm(true);
  }

  const columns = [
	{ label: '', name: 'id', func: null , key: false, item: 'checkbox' },
    { label: 'id', name: 'id', func: (c,l) => l.id.particao + "|" + l.id.offset + "|" + l.id.topico, key: true, width: "20", hidden:true },
    { label: 'Origem Problema', name: 'topico', func: (c,l) => l.id.topico, key: false },
 	{ label: 'Descrição', name: 'observacoes', func: null, key: false, },
  ];
const handleMarcarCheck = (ids) => setListaIds(ids);
	const handleMarcarComResolvidaEmLote = () => {
		EventStreamLogService.resolverErroEmLote(listaIds).then(resultado =>  carregarDados())
		closeDialog();
	};
	
	const actions = []

	actions.push({
		name: () => "Marcar como Ciente",
		icon: <Check />,
		func: (id) => EventStreamLogService.resolverErro(id.topico,id.particao,id.offset).then(resultado =>  carregarDados()) ,
		disabled : () => false
	});

  return (
    <>
      <Toast ref={toastRef} />

      <Title>{pageName}</Title>
	<br/>
      <Filters
        open={true}
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={3}>
          <Grid item sm={12} lg={3}>
            <TextField
              label='Informe parte da descrição do erro'
              value={filtroINEP}
              name='filtroINEP'
              onChange={(e) => setFiltroINEP(e.target.value)}
            />
          </Grid>
        </Grid>
      </Filters>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={null}
        rowsPerPage={null}
        loading={loading}
		handleChecks={handleMarcarCheck}
      />
		<br/>
		<Grid container spacing={3} >
	        <Grid item xs={2} >
	          <ButtonPrimary
	            onClick={() => openDialog("Importante", "Você confirma que está 'ciente' dos erros?", handleMarcarComResolvidaEmLote) }
	            name="Marcar como Ciente"
	            startIcon={<Check />}
	          />
	        </Grid>
		</Grid>
  {openDialogConfirm &&
				<DialogConfirm
					maxWidth={"sm"}
					text={dialogConfirmText}
					close={() => closeDialog(false)}
					open={openDialogConfirm}
					title={dialogConfirmTitle}
					handleConfirm={dialogConfirmAction}
				/>
			}
    </>
  );
}

export default Logs;
